/* eslint-disable no-unused-vars */
import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';

interface PageActionSlotValue {
  node: HTMLElement | null;
  setNode: (node: HTMLElement | null) => void;
}

const PageActionSlotContext = createContext<PageActionSlotValue>({
  node: null,
  setNode: () => undefined,
});

export const PageActionSlotProvider = ({ children }: { children: ReactNode }) => {
  const [node, setNode] = useState<HTMLElement | null>(null);
  const value = useMemo(() => ({ node, setNode }), [node]);

  return <PageActionSlotContext.Provider value={value}>{children}</PageActionSlotContext.Provider>;
};

export const usePageActionSlot = () => useContext(PageActionSlotContext);

export const PageAction = ({ children }: { children: ReactNode }) => {
  const { node } = usePageActionSlot();
  if (!node) return null;
  return createPortal(children, node);
};
